module.exports = __webpack_public_path__ + "img/join_meeting.34656d9d.svg";